export const APP_VIEWPORT_HEIGHT = '100%';
export const APP_HEADER_HEIGHT = '64px';

export const PANEL_BODY_FILL_CLASSNAME = 'flex min-h-0 min-w-0 flex-1 flex-col';

export const APP_PANEL_SCROLL_CLASSNAME = 'overflow-y-auto';

export const PROJECT_PANEL_PADDING_MOBILE = '1rem';
export const PROJECT_PANEL_PADDING_DESKTOP = '2rem';

export const projectPanelPadding = (isMobile: boolean): string =>
  isMobile ? PROJECT_PANEL_PADDING_MOBILE : PROJECT_PANEL_PADDING_DESKTOP;

export const PANEL_TABLE_SCROLL_STYLE = {
  backgroundColor: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: '8px',
  overflow: 'auto',
  flex: 1,
  minHeight: 0,
} as const;

export const APP_SIDEBAR_HEADER_CLASSNAME =
  'box-border flex shrink-0 flex-row items-center overflow-hidden border-b border-border px-2 py-0';

export const APP_SIDEBAR_HEADER_STYLE = {
  height: APP_HEADER_HEIGHT,
  minHeight: APP_HEADER_HEIGHT,
  maxHeight: APP_HEADER_HEIGHT,
} as const;

export const FLOATING_EDITOR_CONTROL_MOBILE_LEFT = '1.3rem';
export const FLOATING_EDITOR_CONTROL_FOCUS_TOP = '1rem';
export const FLOATING_EDITOR_CONTROL_DEFAULT_TOP = `calc(${APP_HEADER_HEIGHT} + 1rem)`;

export const appViewportHeightMinus = (...offsets: string[]): string =>
  `calc(100% - ${offsets.join(' - ')})`;

export const floatingEditorControlTop = (isFocusMode: boolean): string =>
  isFocusMode ? FLOATING_EDITOR_CONTROL_FOCUS_TOP : FLOATING_EDITOR_CONTROL_DEFAULT_TOP;
